// extracted by mini-css-extract-plugin
module.exports = {"searchContain":"MainPage_searchContain__1nq31","search":"MainPage_search__330iu"};